import React, { Component } from 'react';
import { Loading } from '../components/Loading';
import Popup from 'reactjs-popup';
import { Col,Row,Button, Alert,Form } from 'react-bootstrap';
import ServiceCalls from '../utils/serviceCalls.js';
import CommonUtils from '../utils/siteUtils.js';
import TimedDisplay from '../components/TimedDisplay';
import '../styles/Vendor.css';

export class VendorContactPopUp extends Component {

    constructor(props) {
        super(props)
        this.showAlertMessage = this.showAlertMessage.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.postSubmit = this.postSubmit.bind(this);
        this.renderAddContact = this.renderAddContact.bind(this);
        this.renderEditContact = this.renderEditContact.bind(this);
        this.renderRemoveContact = this.renderRemoveContact.bind(this);
        this.renderReplaceContact = this.renderReplaceContact.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
  
        this.state = {          
            userData: {},
            isLoading: false,
            hasError: false,
            submitMsg: '',
            submitMsgLvl: '',
            isUpdateComplete: false,
            isPopupOpen: false,
            validated: false,
            userEmailValid: true,
            userNameValid: true,
            originalContact: null,
            formData: {},
            isModified: false
        }
    }

    resetForm() {
        this.setState({
            submitMsg: '',
            isLoading: false,
            submitMsgLvl: '',
            isUpdateComplete: false,
            isPopupOpen: false,
            validated: false,
            userEmailValid: true,
            userNameValid:true
        });
    }
    postSubmit() {
        this.resetForm();
        this.props.onVendorChange();
    }
   showAlertMessage() {
    if (this.state.isUpdateComplete) {
        return (<TimedDisplay delay="3000" callback={this.postSubmit}>
            <Alert variant={this.state.submitMsgLvl}>{this.state.submitMsg}</Alert>
        </TimedDisplay>);
    }
    else {
        return (<></>);
    }
    }      
    openPopup() {
        // Store original contact data for comparison
        if (this.props.editMode.toUpperCase() === 'EDIT' && this.props.currentContact) {
            this.setState({
                originalContact: { ...this.props.currentContact },
                formData: {
                    name: this.props.currentContact.name,
                    emailId: this.props.currentContact.emailId
                },
                isPopupOpen: true,
                isModified: false 
            });
        } else {
            this.setState({
                isPopupOpen: true,
                isModified: false 
            });
        }
        this.renderForm();
    }
    // US8294730 “Edit” screens to not display the 'Edit' button until something on the form has changed.
    handleInputChange(e) {
        const { name, value } = e.target;
        this.setState(prevState => {
            const updatedFormData = { ...prevState.formData, [name]: value };
            let isModified = false;
            if (prevState.originalContact) {
                // Compare case-insensitively
                const origName = prevState.originalContact.name || '';
                const origEmail = prevState.originalContact.emailId || '';
                const newName = updatedFormData.name || '';
                const newEmail = updatedFormData.emailId || '';
                isModified = (
                    newName.trim().toUpperCase() !== origName.trim().toUpperCase() ||
                    newEmail.trim().toUpperCase() !== origEmail.trim().toUpperCase()
                );
            }
            return { formData: updatedFormData, isModified };
        });
    }

    buildContactRequest(form) {
        const { vendorData } = this.props;
        var id = form.contactId.value;
        var name = form.contactName.value.toUpperCase();
        var email = form.contactEmail.value.toUpperCase();
        var status = form.contactStatus.value.toUpperCase();
        var contactKey = form.contactKey.value.toUpperCase();
        var seqNum = form.contactSeqNum.value;
        var newContact = {
            vendorContactid: Number(id),
            vendorId: vendorData.vendorId,
            vendorSetId: vendorData.vendorSetId,
            vendorRecordId: vendorData.vendorRecordId,
            contactSequenceNumber:Number(seqNum),
            effStatus: status,
            name: name,
            emailId: email,
            contactKey: contactKey
        };
        return newContact;
    }
    handleSubmit(event) {
        const form = event.currentTarget;
        const { editMode, supplierAdmin } = this.props;
        event.preventDefault();
        event.stopPropagation();
        //Check if Supplier Admin exists
        if (!supplierAdmin.email && editMode.toUpperCase() !== 'REMOVE') {
            console.log(`Invalid SPUA. Prevent adding/editing of contacts`);
            this.setState({
                validated: false,
                userNameValid: false,
                userEmailValid: false,
                userNameError: "",
                userEmailError: "Must have a Supplier Admin assigned in order to edit or add contacts",
            });
        }
        else {
            var userEmailValid = CommonUtils.validateEmail(form.contactEmail.value.toLowerCase(), supplierAdmin.email) && form.contactEmail.value.trim().length <= 70;
            var userNameValid = (form.contactName.value.trim().length > 0) && (form.contactName.value.trim().length <= 50);
            var userNameErr = (userNameValid === true) ? "" : (form.contactName.value.trim().length > 0) ? "Maximun length is 50 characters" : "Name is required";
            var userEmailErr = (userEmailValid === true) ? "" : (form.contactEmail.value.trim().length <= 70) ? "A valid email is required" : "Maximun length is 70 characters";
            //console.log(`Users email ${form.contactEmail.value.toLowerCase()} is Valid: ${userEmailValid}`)
            if (form.checkValidity() === false || (userEmailValid === false && editMode.toUpperCase() !== 'REMOVE')) {

                this.setState({
                    validated: userEmailValid,
                    userNameValid: userNameValid,
                    userEmailValid: userEmailValid,
                    userNameError: userNameErr,
                    userEmailError: userEmailErr
                });
            }
            else {
                //VALID
                //MAKE SURE TO SUBMIT ALL VALUES IN CAP LETTERS TO DB
                var newContact = this.buildContactRequest(form);
                this.setState({
                    isLoading: true,
                    validated: true,
                    userEmailValid: userEmailValid,
                    userNameValid: userNameValid
                });
                ServiceCalls.updateVendorContact(newContact).then(function (data) {
                    //Validate results
                    var actionResponse = (editMode.endsWith('e')) ? editMode + 'd' : editMode + 'ed';
                    var errLvl = (data.errorMsg) ? "danger" : "info";
                    var msg = (data.errorMsg) ? `Unable to ${editMode} Contact` : `Successfully ${actionResponse} Contact`;

                    this.setState({
                        isLoading: false,
                        submitMsg: msg,
                        submitMsgLvl: errLvl,
                        isUpdateComplete: true
                    });

                }.bind(this));
            }
        }
    }

    renderForm() {
        const { currentContact, editMode } = this.props;
        switch (editMode.toUpperCase()) {
            case 'ADD':
                return this.renderAddContact();
            case 'EDIT':
                return this.renderEditContact(currentContact);
            case 'REMOVE':
                return this.renderRemoveContact(currentContact);
            case 'REPLACE':
                return this.renderReplaceContact(currentContact);
            default:
        }
    }
    renderAddContact() {
        const { validated, isLoading, submitMsg, userEmailValid, userNameValid, userNameError, userEmailError } = this.state;
     
        return (
            <div className="vContactPopupArea">
                <h4 className="vContactPopupHdr">Add Contact</h4>               
                    <Form noValidate validated={validated} onSubmit={this.handleSubmit}>
                        <Form.Control
                            type="hidden"
                            required
                        placeholder=""                        
                            id="contactId"
                            defaultValue="0" />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="vendorRecordId"
                            defaultValue={this.props.vendorData.vendorRecordId} />
                        <Form.Control
                            type="hidden"
                            required
                            placeholder=""
                            id="contactStatus"
                        defaultValue="A" />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactSeqNum"
                        defaultValue="0" />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactKey"
                        defaultValue="     " />

                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactName">
                            <Form.Label>Name<span className="required">*</span></Form.Label>
                                <Form.Control
                                type="text"
                                required
                                    isInvalid={!userNameValid}
                                    maxLength="50"
                                    autoFocus={ true}
                                placeholder="Name" />
                            <Form.Control.Feedback type="invalid">
                                {userNameError}
                            </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                        <Row className="mb-12">
                            <Form.Group as={Col} className="mb-3" controlId="contactEmail">
                            <Form.Label>Email <span className="required">*</span></Form.Label>
                                <Form.Control
                                type="email"
                                required
                                maxLength="70"
                                placeholder="Email"                                
                                isInvalid={!userEmailValid }
                               />
                                <Form.Control.Feedback type="invalid">
                                {userEmailError}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
                    {(isLoading) ? <Loading /> : (submitMsg) ?
                         this.showAlertMessage()
                        :
                        <Row className="mb-12">
                            <Col>
                                <Button variant="primary" className="right vContactBtn" type="submit">Add</Button>
                                <Button variant="primary" className="right vContactBtn" onClick={this.resetForm}>Cancel</Button>
                            </Col>
                        </Row>
                    }
                    </Form>             
            </div>
            );
    }
    renderEditContact(currentContact) {
        const { validated, isLoading, submitMsg, userEmailValid, userNameValid, userNameError, userEmailError, formData, isModified } = this.state;
        return (
            <div className="vContactPopupArea">
                <h4 className="vContactPopupHdr">Edit Contact</h4>
                <Form noValidate validated={validated} onSubmit={this.handleSubmit}>
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactId"
                        defaultValue={currentContact.vendorContactId} />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="vendorRecordId"
                        defaultValue={this.props.vendorData.vendorRecordId} />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactStatus"
                        defaultValue={currentContact.effStatus} />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactKey"
                        defaultValue={currentContact.contactKey} />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactSeqNum"
                        defaultValue={currentContact.contactSequenceNumber} />
                    <Row className="mb-12">
                        <Form.Group as={Col} className="mb-3" controlId="contactName">
                            <Form.Label>Name<span className="required">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                placeholder="Name"
                                required
                                isInvalid={!userNameValid}
                                maxLength="50"
                                autoFocus={true}
                                
                                value={formData.name || ''}
                                onChange={this.handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                                {userNameError}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className="mb-12">
                        <Form.Group as={Col} className="mb-3" controlId="contactEmail">
                            <Form.Label>Email <span className="required">*</span></Form.Label>
                            <Form.Control
                                type="email"
                                name="emailId"
                                required
                                isInvalid={!userEmailValid}
                                maxLength="70"
                                placeholder="Email"
                               
                                value={formData.emailId || ''}
                                onChange={this.handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                                {userEmailError}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    {(isLoading) ? <Loading /> : (submitMsg) ? this.showAlertMessage() :
                        <Row className="mb-12">
                            <Col>
                                {isModified && (
                                    <Button variant="primary" className="right vContactBtn" type="submit">Edit</Button>
                                )}
                                <Button variant="primary" className="right vContactBtn" onClick={this.resetForm}>Cancel</Button>
                            </Col>
                        </Row>
                    }
                </Form>
            </div>
        );
    }
    renderRemoveContact(currentContact) {

        const { validated, isLoading, submitMsg } = this.state;
        return (
            <div className="vContactPopupArea">
                <h4 className="vContactPopupHdr">Remove Contact</h4>
                <Form noValidate validated={validated} onSubmit={this.handleSubmit}>
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactId"
                        defaultValue={currentContact.vendorContactId} />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="vendorRecordId"
                        defaultValue={this.props.vendorData.vendorRecordId} />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactStatus"
                        defaultValue="I" />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactSeqNum"
                        defaultValue={currentContact.contactSequenceNumber} />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactKey"
                        defaultValue={currentContact.contactKey} />
                    <Row className="mb-12">
                        <Form.Group as={Col} className="mb-3" controlId="contactName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Name"
                                defaultValue={currentContact.name}
                                readOnly
                            />
                        </Form.Group>
                    </Row>
                    <Row className="mb-12">
                        <Form.Group as={Col} className="mb-3" controlId="contactEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                readOnly
                                placeholder="Email"
                                defaultValue={currentContact.emailId}
                                title={currentContact.emailId }
                            />
                         
                        </Form.Group>
                    </Row>
                    {(isLoading) ? <Loading /> : (submitMsg) ?
                        this.showAlertMessage()
                        :
                        <Row className="mb-12">
                            <Col>
                                <Button variant="primary" className="right vContactBtn" type="submit">Remove</Button>
                                <Button variant="primary" className="right vContactBtn" onClick={this.resetForm}>Cancel</Button>
                            </Col>
                        </Row>
                    }
                </Form>
            </div>
        );
    }
    renderReplaceContact(currentContact) {
        const { validated, isLoading, submitMsg, userEmailValid, userNameValid, userNameError, userEmailError } = this.state;
        return (
            <div className="vContactPopupArea">
                <h4 className="vContactPopupHdr">Remove and Replace Contact</h4>
                <Row>
                    <Col>
                        <div><strong>Remove</strong></div>
                        <div>Name: {currentContact.name}</div>
                        <div className="contact-wordwrap">Email: {currentContact.emailId}</div>                        
                    </Col>                        
                </Row>
                <Row>
                    <Col>
                        <div><strong>Replace</strong></div>                       
                    </Col>
                </Row>                
                <Form noValidate validated={validated} onSubmit={this.handleSubmit}>
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactId"
                        defaultValue={currentContact.vendorContactId} />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="vendorRecordId"
                        defaultValue={this.props.vendorData.vendorRecordId} />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactStatus"
                        defaultValue="A" />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactSeqNum"
                        defaultValue={currentContact.contactSequenceNumber} />
                    <Form.Control
                        type="hidden"
                        required
                        placeholder=""
                        id="contactKey"
                        defaultValue={currentContact.contactKey} />
                    <Row className="mb-12">
                        <Form.Group as={Col} className="mb-3" controlId="contactName">
                            <Form.Label>Name <span className="required">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                isInvalid={!userNameValid}
                                required
                                maxLength="50"
                                autoFocus={true}
                                placeholder="Name"
                            />
                            <Form.Control.Feedback type="invalid">
                                {userNameError}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Row>
                    <Row className="mb-12">
                        <Form.Group as={Col} className="mb-3" controlId="contactEmail">
                            <Form.Label>Email<span className="required">*</span></Form.Label>
                            <Form.Control
                                type="email"
                                required
                                maxLength="70"
                                placeholder="Email"
                                isInvalid={!userEmailValid}
                            />
                            <Form.Control.Feedback type="invalid">
                                {userEmailError}
                            </Form.Control.Feedback>
                        </Form.Group>
                
                    </Row>
                    {(isLoading) ? <Loading /> : (submitMsg) ?
                        this.showAlertMessage()
                        :
                        <Row className="mb-12">
                            <Col>
                                <Button variant="primary" className="right vContactBtn" type="submit">Replace</Button>
                                <Button variant="primary" className="right vContactBtn" onClick={this.resetForm}>Cancel</Button>

                            </Col>
                        </Row>
                    }
                </Form>
            </div>
        );
    }
   
    render() {
        const { isPopupOpen } = this.state;
        var btnName = (this.props.editMode.toUpperCase() === "ADD") ? "Add Contact" : this.props.editMode;
        var btnClasses = (this.props.editMode.toUpperCase() === "ADD") ? "vContactBtn right" : "vActionBtn";
        return (
            (!isPopupOpen) ? <Button className={btnClasses} onClick={() => this.openPopup()}>{btnName}</Button>:
                <Popup open={isPopupOpen} modal closeOnDocumentClick={false} closeOnEscape={true} onClose={this.resetForm}>     
                    {close => (this.renderForm())}
            </Popup>
        );
    }
}
